import React from 'react';
import PropTypes from 'prop-types';

import AEMock from './AEMock';
import NamedUserFlyout from './NamedUser/NamedUserFlyout';
import UndefinedAnonymousUser from './UndefinedAnonymousUser';
import AnonymousUserContainer from './AnonymousUser/AnonymousUserContainer';
import Help from './Help';
import History from './History';
import Alerts from './Alerts';

function DashboardNavigationControls({ isAnonymousUser, isAEMock, isPendoResourceCenterEnabled }) {
  return (
    <>
      <History />
      {!isAnonymousUser && <Alerts />}
      <Help isPendoResourceCenterEnabled={isPendoResourceCenterEnabled} />
      {isAEMock && <AEMock />}
      {isAnonymousUser === false && <NamedUserFlyout />}
      {isAnonymousUser === undefined && <UndefinedAnonymousUser />}
      {isAnonymousUser === true && <AnonymousUserContainer />}
    </>
  );
}

DashboardNavigationControls.propTypes = {
  isAnonymousUser: PropTypes.bool,
  isAEMock: PropTypes.bool,
  isPendoResourceCenterEnabled: PropTypes.bool,
};

export default DashboardNavigationControls;
